<template>
  <v-content class="gd-background">
    <router-view></router-view>
    <FooterApps />
  </v-content>
</template>

<script>
import FooterApps from '@/components/FooterApps'

export default {
  name: 'news',
  components: {
    FooterApps
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/News.vue